// https://github.com/parcel-bundler/parcel/issues/3644#issuecomment-542117712
import 'bootstrap/dist/css/bootstrap.css';
import bootstrap from 'bootstrap/dist/js/bootstrap.js';
window.bootstrap = bootstrap;
globalThis.bootstrap = bootstrap;
